export interface Ellipsoid {
    dA: any;
    dB: any;
    dFlat: any;
    dEcc: any;
    dEcc2: any;
    dEcc2Prime: any;
}

export class CoordinateConverter {
    WGS84: Ellipsoid;
    D2R: any;
    R2D: any;
    M_PI_2: any;

    constructor() {
        this.WGS84 = {
            dA: 6378137.0,
            dB: 6356752.3142,
            dFlat: 0.00335281066474,
            dEcc: 0.08181919084255233576686326,
            dEcc2: 0.00669437999013,
            dEcc2Prime: 0.00673949674227
        };
        this.D2R = Math.PI / 180.0;
        this.R2D = 180.0 / Math.PI;
        this.M_PI_2 = 1.57079632679489661923;
    }

    public getBeamformer2D(CntPos: Array<any>, Power: Array<any>, MaxRadius: any): any {
        let Coordiantes: Array<any>;
        Coordiantes = [];
        if (Power.length > 0) {
            var Interval = 0;
            if (Power.length > 1) {
                Interval = 360.0 / Power.length;
            }
            var ScaledPower;
            var Azimuth;
            let Pos: Array<any>;
            Pos = [0, 0, 0];
            for (var i = 0; i < Power.length; ++i) {
                ScaledPower = Power[i] * MaxRadius;
                Azimuth = i * Interval;
                Pos = this.getGeodPosFromRelativePos(CntPos, [0, Azimuth, ScaledPower]);
                Coordiantes.push(Pos[0]);
                Coordiantes.push(Pos[1]);
                Coordiantes.push(CntPos[2]);
            }
            ScaledPower = Power[0] * MaxRadius;
            Azimuth = 360;
            Pos = this.getGeodPosFromRelativePos(CntPos, [0, Azimuth, ScaledPower]);
            Coordiantes.push(Pos[0]);
            Coordiantes.push(Pos[1]);
            Coordiantes.push(CntPos[2]);
        }
        return Coordiantes;
    }

    public getBeamformer3D(CntPos: Array<any>, Power: number[][], MaxRadius: number): number[][] {
        let Coordiantes: Array<any>;
        Coordiantes = [];
        var ElevInterval = 0;
        if (Power.length > 1) {
            ElevInterval = 90.0 / (Power.length - 1);
        }
        for (var i = 0; i < Power.length; ++i) {
            var Elev = ElevInterval * i;
            var AziInterval = 0;
            if (Power[i].length > 1) {
                AziInterval = 360.0 / Power[i].length;
            }
            var ScaledPower;
            var Azi;
            let Pos: Array<any>;
            Pos = [0, 0, 0];
            for (var j = 0; j < Power[i].length; ++j) {
                ScaledPower = Power[i][j] * MaxRadius;
                Azi = j * AziInterval;
                Pos = this.getGeodPosFromRelativePos(CntPos, [Elev, Azi, ScaledPower]);
                Coordiantes.push([Pos[0], Pos[1], Pos[2], Power[i][j]]);
            }
        }
        return Coordiantes;
    }

    public getLine2D(GeodPos: Array<number>, Azi: number, Range: number) {
        let RelativePos: Array<any>;
        RelativePos = [0.0, Azi, Range];
        let Pos: Array<any>;
        Pos = this.getGeodPosFromRelativePos(GeodPos, RelativePos);
        GeodPos[2] = 0;
        Pos[2] = 0;
        return [GeodPos, Pos];
    }

    public getLine3D(GeodPos: Array<number>, Azi: number, Elev: number, Range: number) {
        const RelativePos = [Elev, Azi, Range];
        const Pos = this.getGeodPosFromRelativePos(GeodPos, RelativePos);
        return [GeodPos, Pos];
    }

    public getHyperbolaXY(Baseline:any, Delay:any, MaxY:any) : any {
        let Hyperbola: Array<any>;
        Hyperbola = [];
        var dFocus = Baseline * 0.5;
        if(Math.abs(Delay) < Baseline) {
            if(Delay < 0.0) {
                dFocus = -dFocus;
            }
            var dSemiMajor2 = (Delay * 0.5) * (Delay * 0.5);
            var dFocus2 = dFocus * dFocus;
            var dSemiMinor2 = dFocus2 - dSemiMajor2;
            var dSemiMajor = Math.sqrt(dSemiMajor2);
            var dSemiMinor = Math.sqrt(dSemiMinor2);
            var dAsymptoteAngle = Math.floor(this.R2D * Math.atan(dSemiMinor / dSemiMajor));
            var dStartAngle = 0.0;
            var dEndAngle = 0.0;
            var dStepAngle = 0.0;
            if(Delay >= 0.0) {
                dStartAngle = -dAsymptoteAngle;
                dEndAngle = dAsymptoteAngle;
                dStepAngle = 1.0;
            } else {
                dStartAngle = 180.0 + dAsymptoteAngle;
                dEndAngle = 180.0 - dAsymptoteAngle;
                dStepAngle = -1.0;
            }

            dStartAngle = Math.floor(dStartAngle * dStepAngle);
            dEndAngle = Math.floor(dEndAngle * dStepAngle);
            var dIncrement = Math.floor(Math.abs(dStepAngle));
            for(var i = dStartAngle; i <= dEndAngle; i += dIncrement) {
                var dTgI = Math.tan(i / dStepAngle * this.D2R);
                var dTgI2 = dTgI * dTgI;
                var dDenominator = dSemiMinor2 - dSemiMajor2 * dTgI2;
                if(dDenominator > 0.0) {
                    var dX = 0.0;
                    if(((i / dStepAngle) > -90.0) && ((i / dStepAngle) < 90.0)) {
                        dX = dSemiMajor * dSemiMinor / Math.sqrt(dDenominator);
                    } else {
                        dX = -dSemiMajor * dSemiMinor / Math.sqrt(dDenominator);
                    }
                    var dY = dTgI * dX;
                    if((dY >= -MaxY) && (dY <= MaxY)) {
                        Hyperbola.push(dX);
                        Hyperbola.push(dY);
                    }
                }
            }
      
            if(Hyperbola.length > 1) {
                if(Hyperbola[1] > -MaxY) {
                    var MaxX = 0.0;
                    if(Delay > 0.0) {
                        MaxX = Math.sqrt((1.0 + MaxY * MaxY / dSemiMinor2) * dSemiMajor2);
                    } else {
                        MaxX = -Math.sqrt((1.0 + MaxY * MaxY / dSemiMinor2) * dSemiMajor2);
                    }
                    Hyperbola.unshift(-MaxY);
                    Hyperbola.unshift(MaxX);
                    Hyperbola.push(MaxX);
                    Hyperbola.push(MaxY);
                }
            }
        }
        return Hyperbola;
    }

    public getHyperbola2D(GeodPos1:Array<any>, GeodPos2:Array<any>, Delay:any, MaxY:any) : any {
        let Hyperbola: Array<any>;
        Hyperbola = [];
        let CntPos: Array<any>;
        GeodPos1[2] = 0;
        GeodPos2[2] = 0;
        CntPos = this.getENUPosFromGeodPos(GeodPos1, GeodPos2);
        let Baseline: Array<any>;
        Baseline = this.getRelativePosFromENUPos(CntPos);
        CntPos[0] *= 0.5;
        CntPos[1] *= 0.5;
        CntPos[2] *= 0.5;
        var dPhi = (90.0 - Baseline[1]) * this.D2R;
        var dCPhi = Math.cos(dPhi);
        var dSPhi = Math.sin(dPhi);
        let HyperbolaXY: Array<any>;
        HyperbolaXY = this.getHyperbolaXY(Baseline[2], Delay, MaxY);
        for(var i = 0; i < (HyperbolaXY.length / 2); ++i) {
            let ENUPos: Array<any>;
            ENUPos = [0,0,0];
            ENUPos[0] = HyperbolaXY[i * 2] * dCPhi - HyperbolaXY[i * 2 + 1] * dSPhi + CntPos[0];
            ENUPos[1] = HyperbolaXY[i * 2] * dSPhi + HyperbolaXY[i * 2 + 1] * dCPhi + CntPos[1];
            ENUPos[2] = CntPos[2];
            let GeodPos: Array<any>;
            GeodPos = this.getGeodPosFromENUPos(GeodPos1, ENUPos);
            GeodPos[2] = 0;
            Hyperbola.push(GeodPos);
        }
        return Hyperbola;
    }

    public getHyperbola3D(GeodPos1:Array<any>, GeodPos2:Array<any>, Delay:any, Roll:any, MaxY:any) : any {
        let Hyperbola: Array<any>;
        Hyperbola = [];
        let CntPos: Array<any>;
        CntPos = this.getENUPosFromGeodPos(GeodPos1, GeodPos2);
        let Baseline: Array<any>;
        Baseline = this.getRelativePosFromENUPos(CntPos);
        CntPos[0] *= 0.5;
        CntPos[1] *= 0.5;
        CntPos[2] *= 0.5;
        var dPhi = (90.0 - Baseline[1]) * this.D2R;
        var dCPhi = Math.cos(dPhi);
        var dSPhi = Math.sin(dPhi);
        var dElev = Baseline[0] * this.D2R;
        var dCElev = Math.cos(dElev);
        var dSElev = Math.sin(dElev);
        var dRoll = Roll * this.D2R;
        var dCRoll = Math.cos(dRoll);
        var dSRoll = Math.sin(dRoll);
        let HyperbolaXY: Array<any>;
        HyperbolaXY = this.getHyperbolaXY(Baseline[2], Delay, MaxY);
        for(var i = 0; i < (HyperbolaXY.length / 2); ++i) {
            let RolledPos: Array<any>;
            RolledPos = [0,0,0];
            RolledPos[0] = HyperbolaXY[i * 2];
            RolledPos[1] = HyperbolaXY[i * 2 + 1] * dCRoll;
            RolledPos[2] = HyperbolaXY[i * 2 + 1] * dSRoll;
            let ENUPos1: Array<any>;
            ENUPos1 = [0,0,0];
            ENUPos1[0] = RolledPos[0] * dCElev - RolledPos[2] * dSElev;
            ENUPos1[1] = RolledPos[1];
            ENUPos1[2] = RolledPos[0] * dSElev + RolledPos[2] * dCElev;
            let ENUPos2: Array<any>;
            ENUPos2 = [0,0,0];
            ENUPos2[0] = ENUPos1[0] * dCPhi - ENUPos1[1] * dSPhi + CntPos[0];
            ENUPos2[1] = ENUPos1[0] * dSPhi + ENUPos1[1] * dCPhi + CntPos[1];
            ENUPos2[2] = ENUPos1[2];
            let GeodPos: Array<any>;
            GeodPos = this.getGeodPosFromENUPos(GeodPos1, ENUPos2);
            Hyperbola.push(...GeodPos);
        }
        return Hyperbola;
    }
    
    public getHyperbola3DFilteredHeight(GeodPos1:Array<any>, GeodPos2:Array<any>, Delay:any, Roll:any, MaxY:any, MinH:any, MaxH:any) : any {
        let Hyperbola: Array<any>;
        Hyperbola = [];
        let CntPos: Array<any>;
        CntPos = this.getENUPosFromGeodPos(GeodPos1, GeodPos2);
        let Baseline: Array<any>;
        Baseline = this.getRelativePosFromENUPos(CntPos);
        CntPos[0] *= 0.5;
        CntPos[1] *= 0.5;
        CntPos[2] *= 0.5;
        var dPhi = (90.0 - Baseline[1]) * this.D2R;
        var dCPhi = Math.cos(dPhi);
        var dSPhi = Math.sin(dPhi);
        var dElev = Baseline[0] * this.D2R;
        var dCElev = Math.cos(dElev);
        var dSElev = Math.sin(dElev);
        var dRoll = Roll * this.D2R;
        var dCRoll = Math.cos(dRoll);
        var dSRoll = Math.sin(dRoll);
        let HyperbolaXY: Array<any>;
        HyperbolaXY = this.getHyperbolaXY(Baseline[2], Delay, MaxY);
        for(var i = 0; i < (HyperbolaXY.length / 2); ++i) {
            let RolledPos: Array<any>;
            RolledPos = [0,0,0];
            RolledPos[0] = HyperbolaXY[i * 2];
            RolledPos[1] = HyperbolaXY[i * 2 + 1] * dCRoll;
            RolledPos[2] = HyperbolaXY[i * 2 + 1] * dSRoll;
            let ENUPos1: Array<any>;
            ENUPos1 = [0,0,0];
            ENUPos1[0] = RolledPos[0] * dCElev - RolledPos[2] * dSElev;
            ENUPos1[1] = RolledPos[1];
            ENUPos1[2] = RolledPos[0] * dSElev + RolledPos[2] * dCElev;
            let ENUPos2: Array<any>;
            ENUPos2 = [0,0,0];
            ENUPos2[0] = ENUPos1[0] * dCPhi - ENUPos1[1] * dSPhi + CntPos[0];
            ENUPos2[1] = ENUPos1[0] * dSPhi + ENUPos1[1] * dCPhi + CntPos[1];
            ENUPos2[2] = ENUPos1[2];
            let GeodPos: Array<any>;
            GeodPos = this.getGeodPosFromENUPos(GeodPos1, ENUPos2);
            if((GeodPos[2] >= MinH) && (GeodPos[2] <= MaxH)) {
            	Hyperbola.push(...GeodPos);
            }
        }
        return Hyperbola;
    }

    public getSeriesByInterval(StartValue: any, EndValue: any, Interval: any): any {
        let Series: Array<any>;
        Series = [];
        var Index;
        var Length = Math.round((EndValue + Interval - StartValue) / Interval);
        for (Index = 0; Index < Length; ++Index) {
            var Value = StartValue + Index * Interval;
            Series.push(Value);
        }
        return Series;
    }

    public getSeriesByLength(StartValue: any, EndValue: any, Length: any): any {
        let Series: Array<any>;
        Series = [];
        var Index;
        var Interval = 0;
        if (Length > 1) {
            Interval = (EndValue - StartValue) / (Length - 1);
        }
        for (Index = 0; Index < Length; ++Index) {
            var Value = StartValue + Index * Interval;
            Series.push(Value);
        }
        return Series;
    }

    public getECEFPosFromGeodPos(GeodPos: Array<any>): Array<any> {
        let ECEFPos: Array<any>;
        ECEFPos = [0, 0, 0];
        var dSLat = Math.sin(GeodPos[1] * this.D2R);
        var dCLat = Math.cos(GeodPos[1] * this.D2R);
        var dSLon = Math.sin(GeodPos[0] * this.D2R);
        var dCLon = Math.cos(GeodPos[0] * this.D2R);
        var N = this.WGS84.dA / Math.sqrt(1.0 - this.WGS84.dEcc2 * dSLat * dSLat);
        ECEFPos[0] = (N + GeodPos[2]) * dCLat * dCLon;
        ECEFPos[1] = (N + GeodPos[2]) * dCLat * dSLon;
        ECEFPos[2] = ((1.0 - this.WGS84.dEcc2) * N + GeodPos[2]) * dSLat;
        return ECEFPos;
    }

    public getGeodPosFromECEFPos(ECEFPos: Array<any>): Array<any> {
        let GeodPos: Array<any>;
        GeodPos = [0, 0, 0];
        let rho = Math.sqrt(ECEFPos[0] * ECEFPos[0] + ECEFPos[1] * ECEFPos[1]);
        if (rho == 0.0) {
            GeodPos[0] = 0.0;
            GeodPos[2] = -this.WGS84.dB;
            if (ECEFPos[2] > 0.0) {
                GeodPos[1] = this.M_PI_2 * this.R2D;
            }
            else if (ECEFPos[2] < 0.0) {
                GeodPos[1] = -this.M_PI_2 * this.R2D;
            }
            else {
                GeodPos[1] = 0.0;
                GeodPos[2] = -6371000.0;
            }
            return GeodPos;
        }
        let r = Math.sqrt(ECEFPos[0] * ECEFPos[0] + ECEFPos[1] * ECEFPos[1] + ECEFPos[2] * ECEFPos[2]);
        let mu = Math.atan(((1.0 - this.WGS84.dFlat) * ECEFPos[2] / rho) * (1.0 + (this.WGS84.dEcc2 * this.WGS84.dA) / r));
        GeodPos[1] = Math.atan((ECEFPos[2] + this.WGS84.dEcc2Prime * this.WGS84.dB * Math.pow(Math.sin(mu), 3)) / (rho - this.WGS84.dEcc2 * this.WGS84.dA * Math.pow(Math.cos(mu), 3))) * this.R2D;
        let dN = this.WGS84.dA / Math.sqrt(1.0 - this.WGS84.dEcc2 * Math.pow(Math.sin(GeodPos[1] * this.D2R), 2));
        GeodPos[0] = Math.atan2(ECEFPos[1], ECEFPos[0]) * this.R2D;
        GeodPos[2] = rho / Math.cos(GeodPos[1] * this.D2R) - dN;
        return GeodPos;
    }

    public getENUPosFromRelativePos(RelativePos: Array<any>): Array<any> {
        let ENUPos: Array<any>;
        ENUPos = [0, 0, 0];
        var dSElev = Math.sin(RelativePos[0] * this.D2R);
        var dCElev = Math.cos(RelativePos[0] * this.D2R);
        var dSAz = Math.sin(RelativePos[1] * this.D2R);
        var dCAz = Math.cos(RelativePos[1] * this.D2R);
        ENUPos[0] = dCElev * dSAz * RelativePos[2];
        ENUPos[1] = dCElev * dCAz * RelativePos[2];
        ENUPos[2] = dSElev * RelativePos[2];
        return ENUPos;
    }

    public getRelativePosFromENUPos(ENUPos: Array<any>): Array<any> {
        let RelativePos: Array<any>;
        RelativePos = [0, 0, 0];
        RelativePos[2] = Math.sqrt(ENUPos[0] * ENUPos[0] + ENUPos[1] * ENUPos[1] + ENUPos[2] * ENUPos[2]);
        RelativePos[0] = Math.asin(ENUPos[2] / RelativePos[2]) * this.R2D;
        RelativePos[1] = Math.atan2(ENUPos[0], ENUPos[1]) * this.R2D;
        if (RelativePos[1] < 0.0) {
            RelativePos[1] += 360.0;
        }
        return RelativePos;
    }

    public getECEFPosFromENUPos(ECEFPos1: Array<any>, ENUPos: Array<any>): Array<any> {
        let ECEFPos2: Array<any>;
        ECEFPos2 = [0, 0, 0];
        let GeodPos1: Array<any>;
        GeodPos1 = this.getGeodPosFromECEFPos(ECEFPos1);
        var dSLat = Math.sin(GeodPos1[1] * this.D2R);
        var dCLat = Math.cos(GeodPos1[1] * this.D2R);
        var dSLon = Math.sin(GeodPos1[0] * this.D2R);
        var dCLon = Math.cos(GeodPos1[0] * this.D2R);
        ECEFPos2[0] = -ENUPos[0] * dSLon - ENUPos[1] * dSLat * dCLon + ENUPos[2] * dCLat * dCLon + ECEFPos1[0];
        ECEFPos2[1] = ENUPos[0] * dCLon - ENUPos[1] * dSLat * dSLon + ENUPos[2] * dCLat * dSLon + ECEFPos1[1];
        ECEFPos2[2] = ENUPos[1] * dCLat + ENUPos[2] * dSLat + ECEFPos1[2];
        return ECEFPos2;
    }

    public getECEFPosFromRelativePos(ECEFPos1: Array<any>, RelativePos: Array<any>): Array<any> {
        let ECEFPos2: Array<any>;
        let ENUPos: Array<any>;
        ENUPos = this.getENUPosFromRelativePos(RelativePos);
        ECEFPos2 = this.getECEFPosFromENUPos(ECEFPos1, ENUPos);
        return ECEFPos2;
    }

    public getGeodPosFromENUPos(GeodPos1: Array<any>, ENUPos: Array<any>): Array<any> {
        let ECEFPos1: Array<any>;
        ECEFPos1 = this.getECEFPosFromGeodPos(GeodPos1);
        let ECEFPos2: Array<any>;
        ECEFPos2 = this.getECEFPosFromENUPos(ECEFPos1, ENUPos);
        let GeodPos2: Array<any>;
        GeodPos2 = this.getGeodPosFromECEFPos(ECEFPos2);
        return GeodPos2;
    }

    public getGeodPosFromRelativePos(GeodPos1: Array<any>, RelativePos: Array<any>): Array<any> {
        let ECEFPos1: Array<any>;
        ECEFPos1 = this.getECEFPosFromGeodPos(GeodPos1);
        let ENUPos: Array<any>;
        ENUPos = this.getENUPosFromRelativePos(RelativePos);
        let ECEFPos2: Array<any>;
        ECEFPos2 = this.getECEFPosFromENUPos(ECEFPos1, ENUPos);
        let GeodPos2: Array<any>;
        GeodPos2 = this.getGeodPosFromECEFPos(ECEFPos2);
        return GeodPos2;
    }

    public getENUPosFromECEFPos(ECEFPos1: Array<any>, ECEFPos2: Array<any>): Array<any> {
        let ENUPos: Array<any>;
        ENUPos = [0, 0, 0];
        let GeodPos1: Array<any>;
        GeodPos1 = this.getGeodPosFromECEFPos(ECEFPos1);
        var dX = ECEFPos2[0] - ECEFPos1[0];
        var dY = ECEFPos2[1] - ECEFPos1[1];
        var dZ = ECEFPos2[2] - ECEFPos1[2];
        var dCLat = Math.cos(GeodPos1[1] * this.D2R);
        var dSLat = Math.sin(GeodPos1[1] * this.D2R);
        var dCLon = Math.cos(GeodPos1[0] * this.D2R);
        var dSLon = Math.sin(GeodPos1[0] * this.D2R);
        ENUPos[0] = (-dSLon * dX) + (dCLon * dY);
        ENUPos[1] = (-dSLat * dCLon * dX) - (dSLat * dSLon * dY) + (dCLat * dZ);
        ENUPos[2] = (dCLat * dCLon * dX) + (dCLat * dSLon * dY) + (dSLat * dZ);
        return ENUPos;
    }

    public getENUPosFromGeodPos(GeodPos1: Array<any>, GeodPos2: Array<any>): Array<any> {
        let ENUPos: Array<any>;
        let ECEFPos1: Array<any>;
        ECEFPos1 = this.getECEFPosFromGeodPos(GeodPos1);
        let ECEFPos2: Array<any>;
        ECEFPos2 = this.getECEFPosFromGeodPos(GeodPos2);
        ENUPos = this.getENUPosFromECEFPos(ECEFPos1, ECEFPos2);
        return ENUPos;
    }

    public getRelativePosFromECEFPos(ECEFPos1: Array<any>, ECEFPos2: Array<any>): Array<any> {
        let RelativePos: Array<any>
        let ENUPos: Array<any>;
        ENUPos = this.getENUPosFromECEFPos(ECEFPos1, ECEFPos2);
        RelativePos = this.getRelativePosFromENUPos(ENUPos);
        return RelativePos;
    }

    public getRelativePosFromGeodPos(GeodPos1: Array<any>, GeodPos2: Array<any>): Array<any> {
        let RelativePos: Array<any>
        let ENUPos: Array<any>;
        ENUPos = this.getENUPosFromGeodPos(GeodPos1, GeodPos2);
        RelativePos = this.getRelativePosFromENUPos(ENUPos);
        return RelativePos;
    }
}
